import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext'; 
import { HttpContext } from '../../api-services/HttpService';
import OrderedDataTable from './OrderedDataTableCopy.jsx'; 
import AccountIdsRow from './AccountIdsRow'; 
import EntitledButton from './EntitledButton'; 
import PageInput from './PageInput'; 
import isNumeric from '../functions/isNumeric'; 
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditAccountIdsModal = () => {
    // get context from parent 
    const {
        editAccountIdsModal, 
        setEditAccountIdsModal, 
        editSubCompanyRow,
        setEditSubCompanyRow,
        masterCompanyData, 
        snackbarAlert, 
        editButtonBool, 
    } = useContext(PageContext);
    // get HttpContext from parent
    const {
        GET, 
        POST,
    } = useContext(HttpContext); 
    // initialize state for account ids table 
    const [accountIdsDataList, setAccountIdsDataList] = useState([]); 
    const [accountIdsTableHeader, setAccountIdsTableHeader] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false); 
    // initialize state for add account id
    const [accountId, setAccountId] = useState(''); 
    // useRef to determine intial render 
    const initialRender = useRef(true); 

    // function wrapper to pass row component to datatable 
    const RowComponent = (row, count, tableHeader) => {
        return (
            <>
                <AccountIdsRow row={row} count={count} tableHeader={tableHeader} />
            </>
        ); 
    }

    // event handler for submit new account id 
    const onSubmitClick = () => {
        // validate account id is numeric
        if(!isNumeric(accountId)){
            snackbarAlert(true, 'Error: Invalid Account ID.', 'error'); 
            return; 
        }
        // make post request to api 
        POST('/data/accountids', {
            mastercompanyid: masterCompanyData['mastercompanyid'], 
            companyid: editSubCompanyRow['companyid'],
            accountid: accountId, 
        }).then(res => {
            console.log(res); 
            // default accountId
            setAccountId(accountId => accountId = ''); 
            // show success on snackbar
            snackbarAlert(true, 'Successfully uploaded data.', 'success');
            // refresh data on page
            return getAccountIdsData();
        }).then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err); 
            // show error on snackbar
            snackbarAlert(true, 'Error uploading data.', 'error');
        }); 
    }

    // get account ids to display on table 
    const getAccountIdsData = () => {
        setShowSpinner(showSpinner => showSpinner = true); 
        return new Promise((resolve, reject) => {
            GET('/data/accountids', {
                mastercompanyid: masterCompanyData['mastercompanyid'], 
                companyid: editSubCompanyRow['companyid']
            }).then(res => {
                // set table data 
                setAccountIdsDataList(accountIdsDataList => accountIdsDataList = res['data']['AccountIdsData']); 
                setAccountIdsTableHeader(accountIdsTableHeader => accountIdsTableHeader = res['data']['AccountIdsCols']); 
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                // reject on error 
                reject(err); 
            })
        })
    }

    // useEffect to get accountIdsDatalist on render and editSubCompanyRow change
    useEffect(() => {
        if (!initialRender.current){
            getAccountIdsData().then(res => {
                console.log(res); 
            }).catch(err => {
                console.log(err); 
            }); 
        }
        else {
            initialRender.current = false; 
        }
    }, [editSubCompanyRow]); 

    const settings = {
        getAccountIdsData, 
        editAccountIdsModal, 
        setEditAccountIdsModal, 
        editSubCompanyRow,
        setEditSubCompanyRow,
        masterCompanyData, 
        snackbarAlert, 
        editButtonBool, 
    }

    return(
        <> 
            <PageContext.Provider value={ settings }>
            <CCOffcanvas
                title={`Account Ids for Company ID: ${editSubCompanyRow['companyid']}`}
                show={editAccountIdsModal}
                onCanvasClose={()=>setEditAccountIdsModal(editAccountIdsModal => editAccountIdsModal = false)}
                bodyCssClassName="offcanvas-body"
                offCanvasClassName="offcanvas-parent-card"
                >
                <div className="d-flex flex-column h-100">
                    <div className="p-3 pt-1 trail-section flex-grow-1 overflow-scroll">
                        <div className="bg-white trail-card">
                            {/* { editButtonBool ? 
                                <>
                                    <div class='modal-div'>
                                        <PageInput tag='Add Account ID: ' value={accountId} setValue={setAccountId} />
                                        <EntitledButton entitledBool={editButtonBool} tag='Add Account ID: ' cssClass='accountid-modal-button' onClick={()=>onSubmitClick()}/>
                                    </div>
                                    <br/>
                                </>
                                :<></> } */}
                            <OrderedDataTable RowComponent={RowComponent} tableHeader={accountIdsTableHeader} dataList={accountIdsDataList} showSpinner={showSpinner} skeletonHeight='10vh'
                                sortingEnabled={true} varHeight='145px'
                            />
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent
                            tag={"OK"}
                            border={'#fcd800 1px solid'}
                            background={'#fcd800'}
                            color={'#001317'}
                            onButtonClick={()=>setEditAccountIdsModal(editAccountIdsModal => editAccountIdsModal = false)}
                        />
                    </div>
                </div>
            </CCOffcanvas>
            </PageContext.Provider>
        </>
    );
}

export default EditAccountIdsModal; 